<template>
    <div>
        <transition name="fade" mode="out-in">
            <div key="1" v-if="paso === 1" id="paso-1">
                <BuscarAbonadoComponent @abonadoEncontrado="abonadoEncontrado" :disabled="showInfoAbonado" />

                <b-row v-if="showInfoAbonado && abonado?.info_abonado">
                    <b-col cols="12" class="pt-3">
                        <span class="h3 m-0">Información del abonado a renovar:</span>
                    </b-col>
                    <b-col cols="12" class="p-2 ml-2">
                        <span class="h4 m-0">Nombre completo: {{ abonado.info_abonado.nombre_completo }}</span>
                    </b-col>
                    <b-col cols="12" class="pl-2 pb-2 ml-2">
                        <span class="h4 m-0">Email: {{ abonado.info_abonado.email }}</span>
                    </b-col>
                    <b-col cols="12" class="pl-2 pb-2 ml-2">
                        <span class="h4 m-0">DNI: {{ abonado.info_abonado.dni }}</span>
                    </b-col>
                    <b-col cols="12" v-if="!mostrar_opciones">
                        <button
                            class="button large-button btn-block effect-button"
                            :disabled="disableContinuar"
                            @click="continuarObtenerZonasConAsiento"
                        >
                            <span>Continuar</span>
                        </button>
                    </b-col>
                </b-row>

                <div class="col-12 mt-3" v-if="mostrar_opciones && evento.tiene_recinto">
                    <div class="row">
                        <div class="col-6">
                            <button
                                class="button large-button btn-block effect-button"
                                v-if="asiento_disponible"
                                @click="handleContinuarConAsiento"
                                data-cy="continuar-con-mi-asiento"
                            >
                                <span>Continuar con mi asiento</span>
                            </button>
                            <button class="button large-button btn-block btn-danger" v-else disabled>
                                <small>
                                    El Asiento que corresponde a su abono ya está ocupado / o no hay precios disponibles para este
                                    asiento.
                                </small>
                            </button>
                        </div>
                        <div class="col-6">
                            <button
                                v-if="puede_cambiar"
                                class="button large-button btn-block effect-button"
                                :disabled="isButtonDisabled"
                                @click="handleSeleccionarNuevoAsiento"
                                data-cy="seleccionar-nuevo-asiento"
                            >
                                <span>Seleccionar un nuevo asiento</span>
                            </button>
                        </div>
                    </div>

                    <SeleccionarZonaComponent
                        v-if="evento && abonado_encontrado && puede_cambiar && mostrar_recinto"
                        class="col-12"
                        :evento="evento"
                        :mode="mode"
                        :puede_cambiar="puede_cambiar"
                        :sesion_id="sesion.id"
                        :asientos="asientos"
                        :entradas="entradasLocal"
                        :datos_compradores="datos_compradores"
                        @getZonasFormateadas="getZonasFormateadas"
                        @goTo="finalizarPasoUno"
                    />
                </div>
            </div>
            <div key="2" v-if="paso >= 2" class="mt-3" id="paso-2">
                <PasoDosComponent
                    v-if="zonas && zonas.length > 0"
                    :evento="evento"
                    :zona="zona_seleccionada"
                    :zonas_formateadas="zonas_formateadas"
                    :datos_compradores="datos_compradores"
                    :recinto="recinto"
                    :entradas="entradasLocal"
                    :puede_cambiar="puede_cambiar"
                    :dia_abonado="dia_abonado"
                    :place="evento.place_obj"
                    :continuarConAsiento="continuarConAsiento"
                    :mode="mode"
                    :allow_blocked_seats="true"
                    @resetDatos="resetDatos"
                    @goTo="finalizarPasoDos"
                    @actualizarEntradas="resetPaso3"
                />
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="3" v-if="paso >= 3" class="mt-3" id="paso-3">
                <PasoTresComponent
                    :evento="evento"
                    :abonado="abonado"
                    :event_id="evento.id"
                    :sesion_id="sesion.id"
                    :carrito_id="carrito_id"
                    :datos_compradores="datos_compradores"
                    :entradas_seleccionadas="entradasLocal"
                    :solicitar_datos="evento.solicitar_datos"
                    @goTo="finalizarPasoTres"
                />
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key="4" v-if="paso >= 4" class="mt-3" id="paso-4">
                <PasoCuatroComponent
                    :evento="evento"
                    :mode="mode"
                    :recinto="recinto"
                    :datos_compra="datos_compra"
                    :email="email"
                    :carrito_id="carrito_id"
                    :whatsapp="whatsapp"
                    @goTo="goTo"
                />
            </div>
        </transition>
        <VisibilidadReducida :zona="zona_seleccionada" @aceptar="AceptarVisibilidadReducida"/>
    </div>
</template>

<script>
    import BuscarAbonadoComponent from '@/components/backend/stepper/components/BuscarAbonadoComponent';
    import SeleccionarZonaComponent from '@/components/backend/stepper/components/SeleccionarZonaComponent';
    import PasoDosComponent from '@/components/backend/stepper/eventos/PasoDosComponent.vue';
    import PasoTresComponent from '@/components/backend/stepper/eventos/PasoTresComponent.vue';
    import PasoCuatroComponent from '@/components/backend/stepper/eventos/PasoCuatroComponent.vue';
    import VisibilidadReducida from '@/components/backend/stepper/eventos/Modal/VisibilidadReducida.vue'

    export default {
        props: ['evento', 'sesion', 'recinto', 'entradas', 'paso', 'mode'],
        data() {
            return {
                datos_compradores: [],
                dia_abonado: true,
                zona_seleccionada: null,
                datos_compra: null,
                puede_cambiar: false,
                asientos: [],
                mostrar_opciones: false,
                abonado_encontrado: false,
                asiento_disponible: false,
                carrito_id: null,
                zonas_formateadas: null,
                zonas: [],
                mostrar_recinto: false,
                continuarConAsiento: false,
                abonado: null,
                isButtonDisabled: false,
                showInfoAbonado: false,
                disableContinuar: false,
                entradasLocal: []
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        created(){
            this.entradasLocal = [...this.entradas];
        },
        watch: {
            entradas: {
                handler(newVal){
                    this.entradasLocal = [...newVal]
                },
                deep: true
            }
        },
        methods: {
            handleContinuarConAsiento() {
                this.isButtonDisabled = true;
                this.getZonasContinuarConAsiento(this.puede_cambiar);
            },
            handleSeleccionarNuevoAsiento() {
                this.isButtonDisabled = true;
                this.seleccionarNuevoAsiento();
            },
            resetDatos(new_zona) {
                this.datos_compradores = [];
                this.zona_seleccionada = new_zona;
            },
            getZonasFormateadas(zonas_formateadas){
                this.zonas_formateadas = zonas_formateadas;
                this.zonas = zonas_formateadas;
            },
            continuarConMiAsiento(cambiar) {
                this.continuarConAsiento = true;

                let zona_seleccionada = [];
                for (let i in this.zonas_formateadas) {
                    if (this.zonas_formateadas[i].id === this.asientos[0].asiento.zona_id) {
                        zona_seleccionada = this.zonas_formateadas[i];
                    }
                }

                let abonado = {
                    dia_abonado: 1,
                    datos_compradores: this.datos_compradores,
                    entradas: this.entradasLocal,
                    asientos: this.asientos,
                    puede_cambiar: cambiar
                }

                let seats = []
                for(let i in this.asientos) {
                    seats.push(this.asientos[0].asiento);

                    seats[i].row = this.asientos[0].asiento.fila;
                    seats[i].seat = this.asientos[0].asiento.asiento;
                }

                let params = {
                    filters: {
                        sesion_id: this.$route.params.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    zona_id: zona_seleccionada.id,
                    asientos: seats,
                    datos_abonado: this.datos_compradores,
                    tid: this.configuracion.hash_teatro,
                    taquilla: 1
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    if(res.data.error) {
                        this.$toast.error(res.data.message);
                    } else {
                        this.carrito_id = res.data.session_id;
                        this.$nextTick(function() {
                            this.goTo(3);
                        });
                    }
                }).catch(error => {
                    this.$toast.error("Alguno de los asientos no son válidos o se ha producido un error");
                });

                this.finalizarPasoUno(3, zona_seleccionada, abonado)
            },
            abonadoEncontrado(abonado) {
                this.asientos.push({
                    'apellidos': abonado.info_abonado.apellidos,
                    'asiento': null,
                    'precio': null,
                    'dni': '',
                    'nombre': abonado.info_abonado.nombre,
                    'telefono': ''
                });

                this.abonado_encontrado = true;
                this.datos_compradores.push({});

                if (abonado.asiento_disponible && abonado.precio_reducido.length > 0) {
                    this.asiento_disponible = true;

                    this.asientos[0].precio = {
                        'descripcion': abonado.precio_reducido[0].descripcion,
                        'gd': abonado.precio_reducido[0].price_management_online,
                        'gd_interno': abonado.precio_reducido[0].price_management_online_interno,
                        'id': abonado.precio_reducido[0].id,
                        'precio': abonado.precio_reducido[0].precio,
                        'precio_total': abonado.precio_reducido[0].precio_total,
                        'price_management_taquilla': abonado.precio_reducido[0].price_management_taquilla
                    };

                    if (!abonado.plaza) {
                        this.asientos[0].asiento = {
                            'asiento': abonado.asiento.butaca,
                            'event_ticket_id': abonado.precio_reducido[0].id,
                            'fila': abonado.asiento.fila,
                            'zona_id': abonado.asiento.zona_id,
                            'zona_nombre': abonado.asiento.zona
                        };
                        this.datos_compradores[0].asiento = {
                            'asiento': abonado.asiento.butaca,
                            'event_ticket_id': abonado.precio_reducido[0].id,
                            'fila': abonado.asiento.fila,
                            'zona_id': abonado.asiento.zona_id,
                            'zona_nombre': abonado.asiento.zona
                        };

                        this.datos_compradores[0].id = abonado.info_abonado.id;
                    } else {
                        this.asientos[0].id = abonado.plaza.id;
                        this.asientos[0].butaca = abonado.plaza.butaca;
                        this.asientos[0].fila = abonado.plaza.fila;
                        this.asientos[0].zona_id = abonado.plaza.region_id;
                        this.asientos[0].zona_nombre = abonado.plaza.region_name;
                        this.asientos[0].nombre_sector = abonado.plaza.sector_name;
                        this.asientos[0].event_ticket_id = abonado.precio_reducido[0].id;
                        this.asientos[0].abonado_id = abonado.info_abonado.id;

                        this.datos_compradores[0].id = abonado.plaza.id;
                        this.datos_compradores[0].butaca = abonado.plaza.butaca;
                        this.datos_compradores[0].fila = abonado.plaza.fila;
                        this.datos_compradores[0].zona_id = abonado.plaza.region_id;
                        this.datos_compradores[0].zona_nombre = abonado.plaza.region_name;
                        this.datos_compradores[0].nombre_sector = abonado.plaza.sector_name;
                        this.datos_compradores[0].event_ticket_id = abonado.precio_reducido[0].id;
                        this.datos_compradores[0].abonado_id = abonado.info_abonado.id;
                    }

                }
                this.abonado = abonado;

                if(!abonado.plaza) {
                    this.datos_compradores[0].id = abonado.info_abonado.id;
                }

                this.datos_compradores[0].email = abonado.info_abonado.email;
                this.datos_compradores[0].nombre = abonado.info_abonado.nombre;
                this.datos_compradores[0].apellidos = abonado.info_abonado.apellidos;
                this.datos_compradores[0].abonado_id = abonado.info_abonado.id;

                if (abonado.precio_reducido.length > 0) {
                    this.datos_compradores[0].precios = [];

                    for (let i in abonado.precio_reducido) {
                        this.datos_compradores[0].precios.push({
                            'descripcion': abonado.precio_reducido[i].descripcion,
                            'gd': abonado.precio_reducido[i].price_management_taquilla ?? abonado.precio_reducido[i].price_management,
                            'gd_interno': abonado.precio_reducido[i].price_management_taquilla_interno ?? abonado.precio_reducido[i].price_management_interno,
                            'price_management_interno_taquilla': abonado.precio_reducido[i].price_management_taquilla_interno ?? abonado.precio_reducido[i].price_management_interno,
                            'id': abonado.precio_reducido[i].id,
                            'precio': abonado.precio_reducido[i].precio,
                            'precio_total': abonado.precio_reducido[i].precio_total,
                            'price_management_taquilla': abonado.precio_reducido[0].price_management_taquilla ?? abonado.precio_reducido[i].price_management
                        });
                    }
                }

                this.puede_cambiar = abonado.puede_cambiar_asiento;
                this.$emit('getZonasFormateadas', this.zonas_formated);


                //Si es el majadahonda no puede cambiar de asiento
                if (this.configuracion.hash_teatro == 'xr6ASEHHSAjuAknejBfr') {
                    this.puede_cambiar = false;
                }

                this.showInfoAbonado = true;

                if (this.puede_cambiar) {
                    this.mostrar_opciones = true;
                }
            },
            continuarObtenerZonasConAsiento() {
                this.disableContinuar = true;
                this.$nextTick(function() {
                    this.getZonasContinuarConAsiento();
                });
            },
            getZonasContinuarConAsiento() {
                let array = [];
                const params = {
                    filters: {
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id,
                        abonado_id: this.datos_compradores[0].abonado_id ?? this.datos_compradores[0].id
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;

                    if (this.zonas && this.zonas.length > 0) {
                        for (let zona in this.zonas) {
                            array.push(Object.assign({}, this.zonas[zona]));
                            let precios_array = [];

                            for(let pa in array[zona].precios_abonados) {
                                precios_array.push({
                                    'descripcion': array[zona].precios_abonados[pa].description,
                                    'gd': array[zona].precios_abonados[pa].price_management_taquilla,
                                    'gd_interno': array[zona].precios_abonados[pa].price_management_taquilla_interno,
                                    'id': array[zona].precios_abonados[pa].id,
                                    'precio': array[zona].precios_abonados[pa].price,
                                    'precio_total': array[zona].precios_abonados[pa].price + array[zona].precios_abonados[pa].price_management_taquilla
                                })
                            }

                            array[zona].precios = precios_array;
                            let disponible = precios_array.length > 0 && array[zona].esta_disponible ? true : false;
                            array[zona].esta_disponible = disponible;
                        }

                        this.zonas_formateadas = array;
                        this.continuarConMiAsiento(this.puede_cambiar);
                    } else {
                        if (this.evento.place_obj) {
                            this.getZonasAnexas();
                        }
                    }
                });
            },
            getZonasAnexas() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    recinto_id: this.evento.place_obj.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.taquilla.recinto.zonas-anexas'), params).then(res => {
                    this.zonas_formateadas = res.data.data;

                    let zona_seleccionada = [];
                    for (let i in this.zonas_formateadas) {
                        if (this.zonas_formateadas[i].id === this.asientos[0].zona_id) {
                            zona_seleccionada = this.zonas_formateadas[i];
                        }
                    }

                    let abonado = {
                        dia_abonado: 1,
                        datos_compradores: this.datos_compradores,
                        entradas: this.entradasLocal,
                        asientos: this.asientos,
                        puede_cambiar: false
                    }

                    this.finalizarPasoUno(3, zona_seleccionada, abonado);
                })
            },
            bloquearButacas() {
                const data = this.datos_compradores.map(datos_comprador => {
                    return { plazaId: datos_comprador.id }
                });

                const params = {
                    filters: {},
                    event_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    zona_id: this.zona_seleccionada.id,
                    data: data,
                    datos_abonado: this.abonado.info_abonado
                }

                this.$store.dispatch(this.config.getVuexAlias('back.event.sesiones.zonas.taquilla.bloquear-plazas'), params).then(({ data }) => {
                    sessionStorage.setItem('session_id', data.session_id);
                    this.carrito_id = data.session_id;
                }).catch(() => {
                    this.$toast.error('Butaca/s ocupada/s');
                });
            },
            finalizarPasoUno(paso, zona, abonado) {
                this.datos_compradores = abonado.datos_compradores
                this.entradasLocal = abonado.entradas;
                this.puede_cambiar = abonado.puede_cambiar;

                if(zona.visibilidad_reducida){
                    this.$modal.show('visibilidad-reducida');
                }

                if (paso >= 2) {
                    this.zona_seleccionada = zona;
                }
                if (this.zonas_formateadas.every(zona => zona.tiene_plazas === 1) && this.evento.tiene_recinto) {
                    this.bloquearButacas();
                }

                this.$emit('cambiarPaso', paso)

                this.$nextTick(function() {
                    this.scrollTo('#entradas-seleccionadas');
                });
            },
            finalizarPasoDos(paso, datos, carrito_id) {
                if (carrito_id) {
                    this.carrito_id = carrito_id;
                }

                if (datos) {
                    this.datos_compradores = datos;
                }

                if (Array.isArray(this.entradasLocal) && this.entradas.length > 0) {
                    for (let i = 0; i < this.entradasLocal.length; i++) {
                        if (this.entradasLocal[i].unidades > 0) {
                            for (let x = 0; x < this.entradasLocal[i].unidades; x++) {
                                this.datos_compradores.push({
                                    apellidos: '',
                                    asiento: {
                                        zona_nombre: 'General'
                                    },
                                    descuento: 0,
                                    dni: '',
                                    es_nuevo: true,
                                    nombre: '',
                                    precio: {
                                        descripcion: this.entradasLocal[i].name,
                                        gd: this.entradasLocal[i].price_management,
                                        gd_interno: this.entradasLocal[i].price_management_interno,
                                        price_management_taquilla: this.entradasLocal[i].price_management,
                                        id: this.entradasLocal[i].id,
                                        precio: this.entradasLocal[i].price,
                                        precio_total: this.entradasLocal[i].total_price
                                    },
                                    precios: [
                                        {
                                            descripcion: this.entradasLocal[i].name,
                                            gd: this.entradasLocal[i].price_management,
                                            gd_interno: this.entradasLocal[i].price_management_interno,
                                            id: this.entradasLocal[i].id,
                                            precio: this.entradasLocal[i].price,
                                            price_management_taquilla: this.entradasLocal[i].price_management,
                                            precio_total: this.entradasLocal[i].total_price
                                        }
                                    ],
                                    telefono: '',
                                    url_imprimir: null
                                });
                            }
                        }
                    }
                }

                this.$emit('cambiarPaso', paso)

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            },
            finalizarPasoTres(paso, datos, email, whatsapp) {
                this.email = email;
                this.whatsapp = whatsapp;
                let datos_compra = null
                if (this.zona_seleccionada != null) {
                    datos_compra = {
                        evento_id: this.evento.id,
                        sesion_id: this.sesion.id,
                        zona_id: this.zona_seleccionada.id,
                        datos_compradores: this.datos_compradores,
                        metodo_pago: datos.metodo_pago,
                        modalidad: 0,
                        tipo: false,
                        concepto: datos.concepto,
                        enviar_email: datos.enviar_email,
                        email: datos.email,
                        nombre: datos.nombre,
                        telefono: datos.telefono,
                        enviar_whatsapp: datos.enviar_whatsapp,
                        cp: datos.cp,
                        recinto: true,
                        nombre_comprador: datos.nombre_comprador,
                        apellidos_comprador: datos.apellidos_comprador,
                        dni_comprador: datos.dni_comprador,
                        telefono_comprador: datos.telefono_comprador
                    };
                } else {
                    datos_compra = {
                        evento_id: this.evento.id,
                        sesion_id: this.sesion.id,
                        zona_id: 1,
                        datos_compradores: this.datos_compradores,
                        entradas: this.entradasLocal,
                        metodo_pago: datos.metodo_pago,
                        modalidad: 0,
                        tipo: false,
                        concepto: datos.concepto,
                        enviar_email: datos.enviar_email,
                        email: datos.email,
                        nombre: datos.nombre,
                        telefono: datos.telefono,
                        enviar_whatsapp: datos.enviar_whatsapp,
                        cp: datos.cp,
                        recinto: false,
                        nombre_comprador: datos.nombre_comprador,
                        apellidos_comprador: datos.apellidos_comprador,
                        dni_comprador: datos.dni_comprador,
                        telefono_comprador: datos.telefono_comprador
                    };
                }
                if (datos) {
                    this.datos_compra = datos_compra;
                }
                this.$emit('cambiarPaso', paso)

                this.$nextTick(function() {
                    this.scrollTo('#paso-' + paso);
                });
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            resetPaso3() {
                if (this.paso >= 3) {
                    this.$emit('cambiarPaso', 2)
                    this.$nextTick(function() {
                        this.$emit('cambiarPaso', 3)
                    });
                }
            },
            goTo(paso) {
                if (paso < this.paso) {
                    if (paso === 1) {
                        this.$emit('resetearEntradas', true);
                        this.datos_compra = [];
                        this.datos_compra.metodo_pago = [];
                        this.zona_seleccionada = [];
                        this.datos_compradores = [];
                    }
                    if (paso === 2) {
                        this.$emit('cambiarPaso', 1)
                        this.$emit('resetearEntradas', true);
                        this.datos_compra = null;
                        this.datos_compradores = [];
                        if (!this.evento.tiene_recinto) {
                            this.getEvento();
                        }
                    }
                    this.$nextTick(function() {
                        this.$emit('cambiarPaso', paso)
                    });
                }
            },
            seleccionarNuevoAsiento() {
                if(this.datos_compradores.asiento) {
                    this.datos_compradores.asiento = null;
                }
                this.mostrar_recinto = true;
            },
            AceptarVisibilidadReducida(){
                this.$modal.hide('visibilidad-reducida');
            }
        },
        components: {
            BuscarAbonadoComponent, SeleccionarZonaComponent, PasoDosComponent, PasoTresComponent, PasoCuatroComponent,
            VisibilidadReducida
        }
    }
</script>
